import { render } from "./Gameinside.vue?vue&type=template&id=3dda896b&scoped=true"
import script from "./Gameinside.vue?vue&type=script&lang=js"
export * from "./Gameinside.vue?vue&type=script&lang=js"

import "./Gameinside.vue?vue&type=style&index=0&id=3dda896b&lang=less&scoped=true"

import exportComponent from "D:\\work\\hongy-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dda896b"]])

export default __exports__